// Premium fintech themes - Gold & Green, Light-first with Dark mode

export const themes = {
  // Light Theme (DEFAULT) — Premium fintech aesthetic
  // Clean white/cream background, dark text, gold primary, green success
  light: {
    name: 'Light',
    mode: 'light',
    primary: '#D4AF37',           // Gold — signature accent
    secondary: '#B8941F',         // Deep gold
    accent: '#10B981',            // Emerald green — secondary accent
    background: '#FFFFFF',        // Pure white
    cardBg: '#F9F7F2',            // Warm off-white
    textPrimary: '#1F2937',       // Dark grey/charcoal
    textSecondary: '#6B7280',     // Medium grey
    success: '#10B981',           // Green for gains
    danger: '#EF4444',            // Red for losses
    warning: '#D4AF37',           // Gold for warnings
    borderColor: 'rgba(212, 175, 55, 0.15)' // Subtle gold border
  },

  // Dark Theme — Premium fintech aesthetic (dark variant)
  // Near-black background, light text, gold primary, green success
  dark: {
    name: 'Dark',
    mode: 'dark',
    primary: '#D4AF37',           // Gold — signature accent
    secondary: '#B8941F',         // Deep gold
    accent: '#10B981',            // Emerald green — secondary accent
    background: '#0F0E0C',        // Near-black
    cardBg: 'rgba(30, 29, 25, 0.8)',  // Dark brown-grey
    textPrimary: '#F5F2E9',       // Ivory
    textSecondary: '#A8A294',     // Warm muted grey
    success: '#46C46A',           // Brighter green for dark mode
    danger: '#F87171',            // Brighter red for dark mode
    warning: '#F59E0B',           // Brighter gold for dark mode
    borderColor: 'rgba(212, 175, 55, 0.22)' // Gold hairline
  }
};

export const getTheme = (themeName) => {
  return themes[themeName] || themes.light;
};